export class HeaderSharedData {
    public loadingComboOperators: boolean;
}